export const fallbackLng = "vi";

export const languages = [fallbackLng, "en", "ja", "zh", "ko"] as const;

export type AppLocale = (typeof languages)[number];

export const defaultNS = "common";

export function getOptions(
  lng = fallbackLng,
  ns: string | string[] = defaultNS,
) {
  return {
    supportedLngs: [...languages],
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS: Array.isArray(ns) ? ns[0] : ns,
    ns,
  };
}

export function normalizeLocale(lng: string): AppLocale {
  return languages.includes(lng as (typeof languages)[number])
    ? (lng as AppLocale)
    : fallbackLng;
}
